import { useCallback, useEffect } from "react";
import apiClient from "../api/admin-api-client";
import useAsync from "../hooks/use-async";

export default function useConfig(key) {
    const { data, isIdle, isPending, isError, isSuccess, run } = useAsync();

    useEffect(() => {
        if (!key) return;
        reload();
    }, [ key ]);

    const reload = useCallback(() => run(apiClient(`configs/${key}`)).catch(() => { }));

    return {
        data, 
        isPending: isIdle || isPending,
        isError,
        isSuccess,
        reload,
    };
}